module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/instagram/chapel_sns_05-687b43abf71b2cbbd4663fcbee9d4edf.jpg";